/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function UsersSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    uiGridConstants: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    SearchFilterService: JS5Object,
    UsersService: JS5Object,
) {
    const getData = () => {
        let criteria = {
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            fetchLimit: this.pagingOptions.pageSize,
            includeRoles: true,
            filter: $location.search().searchText
        };

        this.loadingIndicator.show = true;
        UsersService.getAllUsers(criteria).then(() => {
            this.gridOptions.data = PaginationService.pageData;
            this.loadingIndicator.show = false;
        });
    };

    const paginationPreviousPageHandler = () => {
        --this.pagingOptions.currentPage;
        getData();
    };

    const paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        getData();
    };

    const paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        getData();
    };

    const navigateToEditView = (user: JS5Object) => {
        if (_.isNil(user)) {
            $location.url(`system/users/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}`);
        } else {
            $location.url(`system/users/edit/${_.get(user, 'id')}`);
        }
    };
    const navigateToEditViewToCreateUser = () => {
        $location.url('system/users/edit/-1');
    };
    const deleteUser = () => {
        ModalService.showMessageModal({
            messageText: 'Are you sure that you want to delete this user?',
            pullCancelLeft: true,
            title: 'Delete User',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            const userId = _.get(_.first(this.gridApi.selection.getSelectedRows()), 'id');
            UsersService.deleteUser(userId).then(() => {
                getData();
                this.editorForm.$setDirty();
            }).finally(() => {
                this.loadingIndicator.show = false;
            })
        });
    };

    const resetPasswordEnabled = () => {
        let selection = this.gridApi.selection.getSelectedRows();
        return !_.isEmpty(selection) && !selection[0].externalUser;
    };
    const showResetPasswordModal = () => {
        const user = _.first(this.gridApi.selection.getSelectedRows());
        UsersService.showResetPasswordModal(user);
    }


    const columnDefinitions = [
        {
            field: 'username',
            width: 300,
            displayName: 'Username',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'firstName',
            width: 200,
            displayName: 'First Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'lastName',
            width: 200,
            displayName: 'Last Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailAddress',
            width: 300,
            displayName: 'Email',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'roles',
            displayName: 'Groups',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            cellFilter: 'arrayToCsv'
        },
        {
            field: 'adminFlag',
            width: 75,
            displayName: 'Admin',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'externalUser',
            width: 85,
            displayName: 'External',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToEditView(row.entity);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToEditViewToCreateUser
        },
        {
            label: 'Edit',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: () => _.first(this.gridApi.selection.getSelectedRows()),
            onClick: deleteUser
        },
        {
            label: 'Reset Password',
            icon: 'fa-key',
            enabled: resetPasswordEnabled,
            onClick: showResetPasswordModal
        }
    ];

    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PaginationService.resetToDefaultValues();
        SearchFilterService.populateCriteriaFromLocationSearch();
        this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;

        getData();
    };
}

angular.module('prism-ui.users').component('usersSearchView', {
    templateUrl: 'system/users/searchView/users-search-view-template.html',
    controller: UsersSearchViewController
}).filter('arrayToCsv', () => {
    return (array: JS5Object) => {
        return _.chain(array).map('name').value().join(', ');
    }
});
